import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const MoreSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 7.99996C2 8.73329 2.6 9.33329 3.33333 9.33329C4.06667 9.33329 4.66667 8.73329 4.66667 7.99996C4.66667 7.26663 4.06667 6.66663 3.33333 6.66663C2.6 6.66663 2
       7.26663 2 7.99996ZM11.3333 7.99996C11.3333 8.73329 11.9333 9.33329 12.6667 9.33329C13.4 9.33329 14 8.73329 14 7.99996C14 7.26663 13.4 6.66663 12.6667 6.66663C11.9333
       6.66663 11.3333 7.26663 11.3333 7.99996ZM6.66667 7.99996C6.66667 8.73329 7.26667 9.33329 8 9.33329C8.73333 9.33329 9.33333 8.73329 9.33333 7.99996C9.33333 7.26663
       8.73333 6.66663 8 6.66663C7.26667 6.66663 6.66667 7.26663 6.66667 7.99996Z"
      fill="currentColor"
    />
  </svg>
);

const More = (props: IIconProps) => <Icon component={MoreSvg} {...props} />;

export default More;
